import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

const baseUrl = process.env.VUE_APP_BASE_URL;

export const useQuarterlyReportsStore = defineStore('quarterlyReports', () => {
  const quarterlyReports = ref([]);
  const isLoading = ref(false);
  const error = ref(null);

  const fetchQuarterlyReports = async (portfolioId) => {
    isLoading.value = true;
    error.value = null;

    try {
      const token = localStorage.getItem('token'); // Get the token from local storage
      
      if (!portfolioId) {
        const response = await axios.get(`${baseUrl}`+'/api/quarterly-reports/?populate=*', {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the headers
          },
        });      
        // Map the response data to the desired format
        //console.log(response.data.data);
        quarterlyReports.value = response.data.data.map(item => ({
          id: item.id,
          documentId: item.documentId,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
          title: item.Title, // Include the Title field
          document: {
          //   name: item.Document.name,
            url: item.Document.url,
            mime: item.Document.mime,
          },
          portfolio: {
            name: item.portfolio.Name,
          },
        }));
      } else {
        const response = await axios.get(`${baseUrl}`+'/api/quarterly-reports/?populate=*&filters[portfolio][id][$eq]='+`${portfolioId}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the headers
          },
        });      
        // Map the response data to the desired format
        //console.log(response.data.data);
        quarterlyReports.value = response.data.data.map(item => ({
          id: item.id,
          documentId: item.documentId,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
          title: item.Title, // Include the Title field
          document: {
          //   name: item.Document.name,
            url: item.Document.url,
            mime: item.Document.mime,
          },
          portfolio: {
            name: item.portfolio.Name,
          },
        }));        
      }

    } catch (err) {
      error.value = err.response?.data?.message || 'Failed to fetch data'; // Use the error message from the response
    } finally {
      isLoading.value = false;
    }
  };

  return { quarterlyReports, isLoading, error, fetchQuarterlyReports };
});
